import { render } from "./test.vue?vue&type=template&id=7eb68702&ts=true"
import script from "./test.vue?vue&type=script&lang=ts"
export * from "./test.vue?vue&type=script&lang=ts"

import "./test.vue?vue&type=style&index=0&id=7eb68702&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__